import { inject, onBeforeMount, ref } from 'vue';
import EnButton from 'Components/base/EnButton/EnButton.vue';
import EnWidgetCard from 'Components/widgets/EnWidgetCard/EnWidgetCard.vue';
import { EnButtonVariants } from 'Components/types/EnButtonVariants';
import { useI18n } from 'vue-i18n';
import { getUrlParams } from 'Js/utils/urlUtils';
export default {
  __name: 'logout',
  setup(__props, _ref) {
    let __expose = _ref.expose;
    __expose();
    const _useI18n = useI18n(),
      t = _useI18n.t;
    const logoutId = ref('');
    const returnUrl = ref('');
    const breadcrumbInfo = ref([t('Authentication.logout.title')]);
    const _inject = inject('breadcrumb'),
      updateBreadcrumbs = _inject.updateBreadcrumbs;
    updateBreadcrumbs(breadcrumbInfo.value);
    async function tryLogout() {
      const requestBody = {
        returnUrl: returnUrl.value,
        logoutId: logoutId.value
      };
      const response = await fetch("/Account/TryLogout", {
        method: 'POST',
        credentials: 'include',
        //this attaches cookies
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      if (response.ok) {
        if (returnUrl.value) {
          window.location.replace(returnUrl.value);
        } else {
          window.location.replace('/');
        }
      }
    }

    // Don't skip this page for users that look logged out on the client: EN.Auth has no client-side user state
    // (useUserSettingsStore never contains the user here), so such a check redirected every user away without
    // logging them out. /Account/TryLogout is a no-op for users who are already logged out.
    onBeforeMount(() => {
      const params = getUrlParams(window.location);
      returnUrl.value = params['returnurl'];
      logoutId.value = params['logoutId'];
    });
    const __returned__ = {
      t,
      logoutId,
      returnUrl,
      breadcrumbInfo,
      updateBreadcrumbs,
      tryLogout,
      inject,
      onBeforeMount,
      ref,
      EnButton,
      EnWidgetCard,
      get EnButtonVariants() {
        return EnButtonVariants;
      },
      get useI18n() {
        return useI18n;
      },
      get getUrlParams() {
        return getUrlParams;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};